// @ts-check
import BlockCard from '../BlockCard';

// Lifecycle order, matching the ShipmentStatus enum and the ShipmentsPage filter labels.
const STAGES = [
  ['created', 'Created'],
  ['pickup_scheduled', 'Pickup scheduled'],
  ['in_transit', 'In transit'],
  ['out_for_delivery', 'Out for delivery'],
  ['delivered', 'Delivered'],
  ['rto', 'Returned (RTO)'],
  ['cancelled', 'Cancelled'],
  ['exception', 'Exception'],
];

/** Stage bar of shipment counts per status, with the oldest stuck in-transit parcel called out. */
export default function ShipmentsBlock({ block }) {
  const { by_status: byStatus = {}, oldest_stuck_days: oldest = null } = block.data || {};
  const known = new Set(STAGES.map(([k]) => k));
  const rows = [
    ...STAGES.filter(([k]) => byStatus[k] > 0).map(([k, label]) => ({ key: k, label, count: byStatus[k] })),
    // Statuses added to the backend enum later still show, with a readable fallback label.
    ...Object.keys(byStatus).filter((k) => !known.has(k) && byStatus[k] > 0).map((k) => ({ key: k, label: k.replace(/_/g, ' '), count: byStatus[k] })),
  ];
  const max = Math.max(0, ...rows.map((r) => r.count));

  return (
    <BlockCard title="Shipments" href={block.href} headline={block.headline}>
      {rows.length === 0 ? (
        <p className="text-sm text-muted-foreground">No shipments yet</p>
      ) : (
        <>
          <ul className="space-y-2">
            {rows.map((r) => (
              <li key={r.key} data-testid="shipments-stage" className="text-sm">
                <div className="flex items-center justify-between">
                  <span>{r.label}</span>
                  <span className="font-medium">{r.count}</span>
                </div>
                <div className="mt-1 h-2 rounded bg-muted">
                  <div data-testid="shipments-bar" className="h-2 rounded bg-primary" style={{ width: `${(r.count / max) * 100}%` }} />
                </div>
              </li>
            ))}
          </ul>
          {oldest != null && (
            <p className="mt-3 text-sm text-muted-foreground" data-testid="shipments-oldest">
              Oldest stuck: <span className="font-semibold text-foreground">{oldest} days</span>
            </p>
          )}
        </>
      )}
    </BlockCard>
  );
}
